import { JobName } from "../../Enums";
export const SoftwareCompanyPositions: JobName[] = [
  JobName.software0,
  JobName.software1,
  JobName.software2,
  JobName.software3,
  JobName.software4,
  JobName.software5,
  JobName.software6,
  JobName.software7,
];

export const ITCompanyPositions: JobName[] = [JobName.IT0, JobName.IT1, JobName.IT2, JobName.IT3];

export const SecurityEngineerCompanyPositions: JobName[] = [JobName.securityEng];

export const NetworkEngineerCompanyPositions: JobName[] = [JobName.networkEng0, JobName.networkEng1];

export const BusinessCompanyPositions: JobName[] = [
  JobName.business0,
  JobName.business1,
  JobName.business2,
  JobName.business3,
  JobName.business4,
  JobName.business5,
];

export const SecurityCompanyPositions: JobName[] = [
  JobName.security0,
  JobName.security1,
  JobName.security2,
  JobName.security3,
  JobName.security4,
  JobName.security5,
];

export const AgentCompanyPositions: JobName[] = [JobName.agent0, JobName.agent1, JobName.agent2];

export const MiscCompanyPositions: JobName[] = [JobName.waiter, JobName.employee];

export const SoftwareConsultantCompanyPositions: JobName[] = [JobName.softwareConsult0, JobName.softwareConsult1];

export const BusinessConsultantCompanyPositions: JobName[] = [JobName.businessConsult0, JobName.businessConsult1];

export const PartTimeCompanyPositions: JobName[] = [JobName.waiterPT, JobName.employeePT];
